{
  "labels": {
    "signUp": "",
    "signIn": "",
    "paste": "Pegar",
    "pasteAsPlaintext": "Pegar en tèxt brut",
    "pasteCharts": "Pegar los grafics",
    "chartType_bar": "",
    "chartType_line": "",
    "chartType_radar": "",
    "chartType_plaintext": "",
    "selectAll": "Tot seleccionar",
    "multiSelect": "Apondre un element a la seleccion",
    "moveCanvas": "Desplaçar lo canabàs",
    "cut": "Talhar",
    "copy": "Copiar",
    "copyAsPng": "Copiar al quichapapièrs coma PNG",
    "copyAsSvg": "Copiar al quichapapièrs coma SVG",
    "copyText": "Copiar al quichapapièrs coma tèxt",
    "copySource": "Copiar la font al quichapapièrs",
    "convertToCode": "Convertir lo còdi",
    "bringForward": "En avant",
    "sendToBack": "En arrièr",
    "bringToFront": "A l’endavant",
    "sendBackward": "Endarrièr",
    "delete": "Suprimir",
    "copyStyles": "Copiar los estiles",
    "pasteStyles": "Pegar los estils",
    "stroke": "Contorn",
    "changeStroke": "Modificar la color d’emplenament",
    "background": "Rèireplan",
    "changeBackground": "Modificar la color de rèireplan",
    "fill": "Empliment",
    "strokeWidth": "Largor de contorn",
    "strokeStyle": "Estil de contorn",
    "strokeStyle_solid": "Solide",
    "strokeStyle_dashed": "Tiret",
    "strokeStyle_dotted": "Puntilhat",
    "sloppiness": "Estil de traça",
    "pressure": "",
    "pressure_constant": "",
    "pressure_variable": "",
    "opacity": "Opacitat",
    "textAlign": "Alinhament tèxt",
    "edges": "Angles",
    "sharp": "Ponchut",
    "round": "Arredonit",
    "arrowheads": "Cap de la flècha",
    "arrowhead_none": "Cap",
    "arrowhead_arrow": "Sageta",
    "arrowhead_bar": "Barra",
    "arrowhead_circle": "Cèrcle",
    "arrowhead_circle_outline": "Cèrcle (contorn)",
    "arrowhead_triangle": "Triangle",
    "arrowhead_triangle_outline": "Triangle (contirn)",
    "arrowhead_diamond": "Lausange",
    "arrowhead_diamond_outline": "Lausange (contorn)",
    "arrowhead_crowfoot_many": "",
    "arrowhead_crowfoot_one": "",
    "arrowhead_crowfoot_one_or_many": "",
    "arrowhead_cardinality_one": "",
    "arrowhead_cardinality_many": "",
    "arrowhead_cardinality_one_or_many": "",
    "arrowhead_cardinality_exactly_one": "",
    "arrowhead_cardinality_zero_or_one": "",
    "arrowhead_cardinality_zero_or_many": "",
    "more_options": "",
    "cardinality": "",
    "arrowtypes": "",
    "arrowtype_sharp": "",
    "arrowtype_round": "",
    "arrowtype_elbowed": "",
    "fontSize": "Talha polissa",
    "fontFamily": "Familha de polissa",
    "addWatermark": "Apondre « Fabricat amb Excalidraw »",
    "handDrawn": "A la man levada",
    "normal": "Normala",
    "code": "Còdi",
    "small": "Pichona",
    "medium": "Mejana",
    "large": "Granda",
    "veryLarge": "Gradassa",
    "solid": "Solide",
    "hachure": "Raia",
    "zigzag": "Zigzag",
    "crossHatch": "Raia crosada",
    "thin": "Fin",
    "bold": "Espés",
    "left": "Esquèrra",
    "center": "Centre",
    "right": "Drecha",
    "extraBold": "Espesàs",
    "architect": "Arquitècte",
    "artist": "Artista",
    "cartoonist": "Dessenhaire",
    "fileTitle": "Nom del fichièr",
    "colorPicker": "Selector de color",
    "canvasColors": "Utilizada suls canabassses",
    "canvasBackground": "Rèireplan del canabàs",
    "drawingCanvas": "Zòna de dessenh",
    "clearCanvas": "Escafar canabàs",
    "layers": "Calques",
    "actions": "Accions",
    "language": "Lenga",
    "liveCollaboration": "Collaboracion en dirèct...",
    "duplicateSelection": "Duplicar",
    "untitled": "Sens títol",
    "name": "Nom",
    "yourName": "Vòstre nom",
    "madeWithExcalidraw": "Fabricat amb Excalidraw",
    "group": "Gropar la seleccion",
    "ungroup": "Desunir la seleccion",
    "collaborators": "Collaborators",
    "you": "",
    "toggleGrid": "",
    "loadingScene": "Cargament de la scèna…",
    "loadScene": "Cargar una scèna d’un fichièr",
    "align": "Alinhament",
    "alignTop": "Alinhar ennaut",
    "alignBottom": "Alinhar enbàs",
    "alignLeft": "Alinhar a esquèrra",
    "alignRight": "Alinhar a drecha",
    "centerVertically": "Centrar verticalament",
    "centerHorizontally": "Centrar orizontalament",
    "distributeHorizontally": "Distribuir orizontalament",
    "distributeVertically": "Distribuir verticalament",
    "flipHorizontal": "Virar orizontalament",
    "flipVertical": "Virar verticalament",
    "viewMode": "Mòde de vista",
    "share": "Partejar",
    "showStroke": "Mostrar lo selector de color de contorn",
    "showBackground": "Mostrar lo selector de color de fons",
    "showFonts": "Mostrar lo selector de polissa",
    "toggleTheme": "",
    "theme": "Tèma",
    "decreaseFontSize": "Reduire talha polissa",
    "increaseFontSize": "Aumentar talha polissa",
    "unbindText": "Dessociar lo tèxte",
    "bindText": "Ligar lo tèxt al contenidor",
    "createContainerFromText": "Envelopar lo tèxte dins un contenedor",
    "link": {
      "edit": "Modificar lo ligam",
      "editEmbed": "",
      "create": "Apondre un ligam",
      "label": "Ligam",
      "labelEmbed": "Ligam e integracion",
      "empty": "Cap de ligam pas definit",
      "hint": "",
      "goToElement": ""
    },
    "lineEditor": {
      "edit": "Modificar la linha",
      "editArrow": "Modificar sageta"
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "Verrolhar",
      "unlock": "Desverrolhar",
      "lockAll": "Tot verrolhar",
      "unlockAll": "Tot desverrolhar"
    },
    "sidebarLock": "Gardar la barra laterala dobèrta",
    "selectAllElementsInFrame": "Seleccionar totes los elements del quadre",
    "removeAllElementsFromFrame": "Tirar totes los elements d’al quadre",
    "eyeDropper": "Prendre la color a partir d’un canabàs",
    "followUs": "Seguissètz-nos",
    "discordChat": "Chat Discord",
    "zoomToFitViewport": "",
    "zoomToFitSelection": "",
    "zoomToFit": "",
    "installPWA": "",
    "autoResize": "",
    "imageCropping": "Talhatge d’imatge",
    "unCroppedDimension": "",
    "copyElementLink": "Copiar lo ligam cap a l’objècte",
    "linkToElement": "Ligam cap a l’objècte",
    "wrapSelectionInFrame": "",
    "tab": "Onglet",
    "shapeSwitch": "",
    "preferences": "",
    "preferences_toolLock": "",
    "boxSelectionMode": "",
    "boxSelectionContain": "",
    "boxSelectionOverlap": "",
    "arrowBinding": "",
    "midpointSnapping": ""
  },
  "elementLink": {
    "title": "",
    "desc": "",
    "notFound": ""
  },
  "search": {
    "title": "",
    "noMatch": "",
    "singleResult": "resultat",
    "multipleResults": "resultats",
    "placeholder": "",
    "frames": "",
    "texts": "Tèxtes"
  },
  "buttons": {
    "clearReset": "Reïnicializar lo canabàs",
    "exportJSON": "Exportar en fichièr",
    "exportImage": "Exportar imatges...",
    "export": "Enregistrar dins...",
    "copyToClipboard": "Copiar al quichapapièrs",
    "copyLink": "Copiar ligam",
    "save": "Salvar al fichièr actual",
    "saveAs": "Enregistrar jos",
    "load": "Dobrir",
    "getShareableLink": "Obténer lo ligam de partatge",
    "close": "Tampar",
    "selectLanguage": "Causir una lenga",
    "scrollBackToContent": "Tornar al contengut",
    "zoomIn": "Zoom avant",
    "zoomOut": "Zoom arrièr",
    "resetZoom": "Tirar lo zoom",
    "menu": "Menú",
    "done": "Acabat",
    "edit": "Modificar",
    "undo": "Anullar",
    "redo": "Restablir",
    "createNewRoom": "Crear sala novèla",
    "fullScreen": "Ecran complèt",
    "darkMode": "Mòde escur",
    "lightMode": "Mòde clar",
    "systemMode": "Mòde sistèma",
    "zenMode": "Mòde escur",
    "objectsSnapMode": "Ancorar als objèctes",
    "exitZenMode": "Sortir del mòde zen",
    "cancel": "Anullar",
    "clear": "Escafar",
    "remove": "Tirar",
    "embed": "Alternar l’integracion",
    "submit": "Enviar",
    "confirm": "Confirmar",
    "embeddableInteractionButton": "Clicar per interagir"
  },
  "alerts": {
    "clearReset": "Aquò suprimirà lo canabàs complèt. O volètz vertadièrament ?",
    "couldNotCreateShareableLink": "Creacion impossibla del ligam de partatge.",
    "couldNotCreateShareableLinkTooBig": "Creacion impossibla del ligam de partatge : la scèna es tròp granda",
    "couldNotLoadInvalidFile": "Cargament impossible d’un fichièr invalid",
    "importBackendFailed": "Importacion fracassada.",
    "cannotExportEmptyCanvas": "Impossible d’exportar los canabasses voids.",
    "couldNotCopyToClipboard": "Còpia impossibla al quichapapièrs.",
    "decryptFailed": "Deschiframent impossible de las donadas.",
    "uploadedSecurly": "Lo telecargament es estat securizat amb un chiframent del cap a la fin, significa que los servidors d’Excalidraw o que quina tèrça part que siá pòdon pas legir lo contengut.",
    "loadSceneOverridePrompt": "Cargar un dessenh extèrn remplaçarà vòstre contengut existent. Volètz contunhar ?",
    "collabStopOverridePrompt": "Arrestar la session remplaçarà vòstre precedent dessenh gardat localament. O volètz vertadièrament ?\n\n(Se volètz gardar vòstre dessenh local, tampatz simplament l’onglet del navegador a la plaça)",
    "imageDoesNotContainScene": "Aqueste imatge sembla pas conténer cap de donadas de scèna. Avètz activat l’integracion de scèna pendent l’exportacion ?",
    "cannotRestoreFromImage": "Restauracion impossibla de la scèna a partir del fichièr imatge",
    "invalidSceneUrl": "Importacion impossibla de la scèna a partir de l’URL provesida. Es siá mal formatada o siá conten pas cap de donada JSON Excalidraw valida.",
    "invalidEncryptionKey": "La clau de chiframent deu conténer 22 caractèrs. La collaboracion en dirèct es desactivada.",
    "collabOfflineWarning": "Cap de connexion pas disponibla.\nVòstras modificacions seràn pas salvadas !",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "Tipe de fichièr pas pres en carga.",
    "imageInsertError": "Insercion d’imatge impossibla. Tornatz ensajar mai tard...",
    "fileTooBig": "Fichièr tròp pesuc. La talha maximala autorizada es {{maxSize}}.",
    "svgImageInsertError": "Insercion d’imatge SVG impossibla. Las balisas SVG semblan invalidas.",
    "failedToFetchImage": "Fracàs de la recuperacion de l’imatge.",
    "cannotResolveCollabServer": "Connexion impossibla al servidor collab. Mercés de recargar la pagina e tornar ensajar.",
    "collabSaveFailed": "Enregistrament impossible dins la basa de donada del backend. Se lo problèma persistís, deuriatz enregistrar lo fichièr localament per vos assegurar que perdretz pas vòstre trabalh.",
    "collabSaveFailed_sizeExceeded": "Enregistrament impossible dins la basa de donada del backend, lo canabàs sembla tròp pesuc. Deuriatz enregistrar lo fichièr localament per vos assegurar que perdretz pas vòstre trabalh.",
    "imageToolNotSupported": "Los imatges son desactivats.",
    "brave_measure_text_error": {
      "line1": "Semblatz utilizar lo navegador Brave amb lo paramètre <bold>Blocatge agressiu de las emprentas numericas</bold> activat.",
      "line2": "Aquò pòt menar a copar <bold>l’element Tèxte</bold> de vòstres dessenhs.",
      "line3": "Recomandam fòrt de desactivar aqueste paramètre. Podètz seguir <link>aquestas etapas</link> per veire cossí o far.",
      "line4": "Se la desactivacion d'aqueste paramètre corregís pas l'afichatge dels elements de tèxt, vos convidam a dobrir un <issueLink>tiquet</issueLink> sus nòstre GitHub, o a nos escriure sus <discordLink>Discord</discordLink>"
    },
    "asyncPasteFailedOnRead": "Empegatge impossible (lectura impossibla a partir del quichapapièrs).",
    "asyncPasteFailedOnParse": "Empegatge impossible.",
    "copyToSystemClipboardFailed": "Còpia impossibla al quichapapièrs."
  },
  "toolBar": {
    "selection": "Seleccion",
    "lasso": "",
    "image": "Inserir imatge",
    "rectangle": "Rectangle",
    "diamond": "Lausange",
    "ellipse": "Ellipsa",
    "arrow": "Sageta",
    "line": "Linha",
    "freedraw": "Dessenhar",
    "text": "Tèxt",
    "lock": "Mantenir activa l’aisina aprèp dessenhar",
    "penMode": "Mòde estilo - empachar lo contact",
    "link": "",
    "eraser": "Goma",
    "frame": "Esplech quadre",
    "embeddable": "Integracion Web",
    "laser": "Puntador laser",
    "autoshape": "",
    "bucketfill": "",
    "hand": "Man (aisina de desplaçament de la vista)",
    "extraTools": "Mai d’aisinas",
    "convertElementType": ""
  },
  "bucketfill": {
    "noRegion": "",
    "tooComplex": ""
  },
  "element": {
    "rectangle": "Rectangle",
    "diamond": "",
    "ellipse": "Ellipsa",
    "arrow": "Sageta",
    "line": "Linha",
    "freedraw": "",
    "text": "Tèxt",
    "image": "Imatge",
    "group": "Grop",
    "frame": "Quadre",
    "embeddable": "",
    "selection": "Seleccion",
    "iframe": ""
  },
  "headings": {
    "canvasActions": "Accions del canabàs",
    "selectedShapeActions": "Accions per la forma seleccionada",
    "shapes": "Formas"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "Clicatz per començar mantun punt, lisatz per una sola linha",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "Clicatz e lisatz, relargatz un còp acabat",
    "text": "Astúcia : podètz tanben apondre de tèxt en doble clicant ont que siá amb l’aisina de seleccion",
    "embeddable": "",
    "autoshape": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "toggleArrowhead": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "bindTextToElement": "{{shortcut}} per apondre un tèxt",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "Afichatge impossible de l’apercebut",
    "canvasTooBig": "Lo canabàs pòt èsser tròp grand.",
    "canvasTooBigTip": "Astúcia : ensajatz de sarrar los elements mai alonhats."
  },
  "errorSplash": {
    "headingMain": "Una error s’es producha. Ensajatz <button>recargament de la pagina.</button>",
    "clearCanvasMessage": "Se recargar fonciona pas, ensajatz <button>d’escafar los canabasses.</button>",
    "clearCanvasCaveat": " Menarà a una pèrda del trabalh ",
    "trackedToSentry": "Error amb l’identificant {{eventId}} es estada enregistrada sus nòstre sistèma.",
    "openIssueMessage": "Èrem plan prudents per inclure pas d’informacions de la scèna vòstra sus l’error. Se vòstra scèna es pas privada, volgatz considerar de perseguir sus nòstre <button>traçadors d’avarias.</button> Volgatz inclure las informacions çai-jos en las copiant e pegant a l’issue GitHub.",
    "sceneContent": "Contengut de la scèna :"
  },
  "shareDialog": {
    "or": "O"
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "Començar la session",
    "button_stopSession": "Arrestar la session",
    "desc_inProgressIntro": "La session de collaboracion es ara en cors.",
    "desc_shareLink": "Partejatz aqueste ligam amb lo monde amb qui volètz collaborar :",
    "desc_exitSession": "Arrestar la session vos desconnectarà de la sala, mas poiretz contunhar de trabalhar a la scèna, en local. Notatz qu’aquò afectarà pas los autres, e poiràn collaborar a lor version.",
    "shareTitle": "Rejonhètz una session collaborativa sus Excalidraw"
  },
  "errorDialog": {
    "title": "Error"
  },
  "progressDialog": {
    "title": "",
    "defaultMessage": ""
  },
  "exportDialog": {
    "disk_title": "Salvar al disc",
    "disk_details": "Exportar las donadas de la scèna cap a un fichièr que podètz importar mai tard.",
    "disk_button": "Salvar al fichièr",
    "link_title": "Ligam de partejar",
    "link_details": "Exportar coma un ligam de lectura sola.",
    "link_button": "Exportar en ligam",
    "excalidrawplus_description": "Enregistrar la scèna dins vòstre espaci de trabalh Excalidraw+.",
    "excalidrawplus_button": "Exportar",
    "excalidrawplus_exportError": "Export impossibla cap a Excalidraw+ pel moment..."
  },
  "helpDialog": {
    "blog": "Legir nòstre blog",
    "click": "clic",
    "deepSelect": "Seleccion prigonda",
    "deepBoxSelect": "Seleccionar demest un grop e empacha lo desplaçament",
    "createFlowchart": "",
    "navigateFlowchart": "",
    "curvedArrow": "Sageta corba",
    "curvedLine": "Linha corba",
    "documentation": "Documentacion",
    "doubleClick": "doble clic",
    "drag": "lisar",
    "editor": "Editor",
    "editLineArrowPoints": "Modificar los ponches de linha/sageta",
    "editText": "Modificar tèxt / apondre etiqueta",
    "github": "Problèma trobat ? Senhalatz-lo",
    "howto": "Seguissètz nòstras guidas",
    "or": "o",
    "preventBinding": "Empachar la fixacion de sagetas",
    "tools": "Aisinas",
    "shortcuts": "Acorchis clavièr",
    "textFinish": "Terminar l’edicion (editor de tèxt)",
    "textNewLine": "Apondre linha novèl (editor de tèxt)",
    "title": "Ajuda",
    "view": "Vista",
    "zoomToFit": "Zoomar per veire totes los elements",
    "zoomToSelection": "Zoomar la seleccion",
    "toggleElementLock": "Verrolhar/Desverrolhar la seleccion",
    "movePageUpDown": "Desplaçar la pagina ennaut/enbàs",
    "movePageLeftRight": "Desplaçar la pagina a esquèrra/drecha",
    "cropStart": "",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": "Escafar canabàs"
  },
  "imageExportDialog": {
    "header": "Exportar imatges",
    "label": {
      "withBackground": "Rèireplan",
      "onlySelected": "Seleccion sonque",
      "darkMode": "Mòde escur",
      "embedScene": "Embarcar la scèna",
      "scale": "Escala",
      "padding": "Espaçament"
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "Exportar en PNG",
      "exportToSvg": "Exportar en SVG",
      "copyPngToClipboard": "Copiar PNG al quichapapièrs"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Copiar al quichapapièrs"
    }
  },
  "encrypted": {
    "tooltip": "Vòstres dessenhs son chifrats del cap a la fin en consequéncia los servidors d’Excalidraw los veiràn pas jamai.",
    "link": "Article de blòg sul chiframent del cap a la fin dins Excalidraw"
  },
  "stats": {
    "angle": "Angle",
    "shapes": "Fòrmas",
    "height": "Nautor",
    "scene": "Scèna",
    "selected": "Seleccionat",
    "storage": "Emmagazinatge",
    "fullTitle": "Proprietats de canabàs e de fòrmas",
    "title": "Propietats",
    "generalStats": "General",
    "elementProperties": "Proprietats de fòrma",
    "total": "Total",
    "version": "Version",
    "versionCopy": "Clicar per copiar",
    "versionNotAvailable": "Version pas disponibla",
    "width": "Largor"
  },
  "toast": {
    "copyStyles": "Estiles copiats.",
    "copyToClipboard": "Copiats al quichapapièrs.",
    "copyToClipboardAsPng": "{{exportSelection}} copiat coma PNG ({{exportColorScheme}})",
    "copyToClipboardAsSvg": "",
    "fileSaved": "Fichièr enregistrat.",
    "fileSavedToFilename": "Enregistrat jos {filename}",
    "canvas": "canabàs",
    "selection": "seleccion",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": "",
    "elementLinkCopied": "Copiats al quichapapièrs"
  },
  "colors": {
    "transparent": "Transparéncia",
    "black": "Negre",
    "white": "Blanc",
    "red": "Roge",
    "pink": "Ròse",
    "grape": "Bordèu",
    "violet": "Violet",
    "gray": "Gris",
    "blue": "Blau",
    "cyan": "Cian",
    "teal": "Sarcèla",
    "green": "Verd",
    "yellow": "Jaune",
    "orange": "Irange",
    "bronze": "Bronze"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "Voliatz puslèu utilizar Excalidraw+ a la plaça ?",
      "menuHint": "Exportar, preferéncias, lengas, ..."
    },
    "defaults": {
      "menuHint": "Exportar, preferéncias, e mai...",
      "center_heading": "Diagram. Tot. Simplament.",
      "toolbarHint": "Prenètz un esplech e començatz de dessenhar !",
      "helpHint": "Acorchis e ajuda"
    }
  },
  "colorPicker": {
    "color": "Color",
    "mostUsedCustomColors": "Colors personalizadas mai utilizadas",
    "colors": "Colors",
    "shades": "Nuanças",
    "hexCode": "Còdi exadecimal",
    "noShades": "Cap de nuança pas disponibla per aquesta color",
    "invalidColor": "",
    "invalidHexLength": "",
    "topPicksTip": "",
    "resetTopPicks": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Exportar coma imatge",
        "button": "Exportar coma imatge",
        "description": "Exportar las donadas de la scèna coma un imatge que podètz importar mai tard."
      },
      "saveToDisk": {
        "title": "Salvar al disc",
        "button": "Salvar al disc",
        "description": "Exportar las donadas de la scèna cap a un fichièr que podètz importar mai tard."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Exportar dins Excalidraw+",
        "description": "Enregistrar la scèna dins vòstre espaci de trabalh Excalidraw+."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Cargar d’un fichièr",
        "button": "Cargar d’un fichièr",
        "description": "Lo cargament dempuèi un fichièr <bold>remplaçarà vòstre contengut actual</bold>.<br></br>Podètz d'en primièr far una còpia de seguretat de vòstre dessenh en utilizant una de las opcions çaijós."
      },
      "shareableLink": {
        "title": "Cargar d’un ligam",
        "button": "Remplaçar mon contengut",
        "description": "Lo cargament d'un dessenh extèrne <bold>remplaçarà vòstre contengut existent</bold>.<br></br>Podètz d'en primièr far una còpia de seguretat de vòstre dessenh en utilizant una de las opcions çaijós."
      }
    }
  },
  "quickSearch": {
    "placeholder": "Recèrca rapida"
  },
  "fontList": {
    "badge": {
      "old": "ancian"
    },
    "sceneFonts": "Dins aquesta scèna",
    "availableFonts": "Polissas disponiblas",
    "empty": "Cap de polissa pas trobada"
  },
  "userList": {
    "empty": "Cap d’utilizaire pas trobat",
    "hint": {
      "text": "Clicar l’utilizaire per lo seguir",
      "followStatus": "Seguissètz actualament aqueste utilizaire",
      "inCall": "L’utilizaire es en conversacion vocala",
      "micMuted": "Lo microfòn de l’utilizaire es mut",
      "isSpeaking": "La persona parla"
    }
  },
  "keys": {
    "ctrl": "Ctrl",
    "option": "Opcion",
    "cmd": "Cmd",
    "alt": "Alt",
    "escape": "Esc",
    "enter": "Entrada",
    "shift": "Maj",
    "spacebar": "Espaci",
    "delete": "Suprimir",
    "mmb": "Clic rodeta"
  }
}
